/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

 /**
 * ----------------------------------------------------------------------------------------------
 * Accordion component
 * ----------------------------------------------------------------------------------------------
 */

$( function() {
  $( "#accordion" ).accordion({
      collapsible: true,
      heightStyle: "content"
  });
});

/**
 * ----------------------------------------------------------------------------------------------
 * Gallery component
 * ----------------------------------------------------------------------------------------------
 */

$(document).ready(function() {

	// Homepage Content Tiles Slider
	if ($('#content-tiles__slider--homepage').length) {
		var $contentTilesSlider = $("#content-tiles__slider--homepage")
		.on("init", function(slick) {
			$('#content-tiles__slider--homepage').fadeIn(1000);
		})
		.slick({
			rows: 1,
			dots: false,
			mobileFirst: true,
			infinite: false,
			slidesToShow: 1.2,
			slidesToScroll: 1,
			arrows: true,
			prevArrow:"<button class='button button--arrow slick--prev' aria-label='Previous Slide'><img alt='Previous Slide' src='//sbd-employee-store-ca-staging.myshopify.com/cdn/shop/t/3/assets/btn-arrow--right.svg?v=89986805987909468501683528818'></button>",
			nextArrow:"<button class='button button--arrow slick--next' aria-label='Next Slide'><img alt='Next Slide' src='//sbd-employee-store-ca-staging.myshopify.com/cdn/shop/t/3/assets/btn-arrow--right.svg?v=89986805987909468501683528818'></button>",
			responsive: [
				{
					breakpoint: 600,
					settings: {
						slidesToShow: 2.2,
						slidesToScroll: 1
					}
				},
				{
					breakpoint: 992,
					settings: {
						slidesToShow: 2.5,
						slidesToScroll: 1
					}
				},
				{
					breakpoint: 1200,
					settings: "unslick"
				}
			]
		});
	}

  $(window).resize(function() {
    clearTimeout(window.resizedFinished);
    window.resizedFinished = setTimeout(function(){
      if (window.screen.width < 900) {
        $('#content-tiles__slider--homepage')[0].slick.refresh();
      }
    }, 250);
  });

});

/**
 * ----------------------------------------------------------------------------------------------
 * Student/staff form state and school dropdown
 * ----------------------------------------------------------------------------------------------
 */

var countryValues =[];
var countryState = {};
var stateSchools = {};

$(".customer-registration input").click(function(e) {
	if(($(this).val() === 'UserType:STPStudent') || ($(this).val() === 'UserType:STPStaff')){
		$(this).parents("form").find('.states').show();
		$(this).parents("form").find('.schools').show();
		var target = $(this).parents("form").find('#states');
		target.empty();
		$('<option id="' + "Please Select" + '" value="' + "Please Select" + '">' + "Select State" + '</option>').appendTo(target);
		var states = countryState['USM'];
		if (states != undefined) {
			states.sort();
			for(var i = 0; i < states.length; i++) {
				$('<option id="' + states[i] + '" value="' + states[i] + '">' + states[i] + '</option>').appendTo(target);
			}
		}
	} else if($(this).val() === 'National Partner') {
		$(this).parents("form").find('.states').hide();
		$(this).parents("form").find('.schools').hide();
      	$(this).parents("form").find('.states option').remove();
		$(this).parents("form").find('.schools option').remove();
	} else {
		$(this).parents("form").find('.states').hide();
		$(this).parents("form").find('.schools').hide();
      	$(this).parents("form").find('.states option').remove();
		$(this).parents("form").find('.schools option').remove();
	}
});

$('#states').on('change', function () {
	var target = $(this).parents(".register-form").find('#schools');
	target.empty();
	$('<option id="' + "Please Select" + '" value="' + "Please Select" + '">' + "Select School" + '</option>').appendTo(target);
	var schools = stateSchools[$(this).val()];
	if (states != undefined) {
		schools.sort();
		for(var i = 0; i < schools.length; i++) {
			$('<option id="' + schools[i] + '" value="' + schools[i] + '">' + schools[i] + '</option>').appendTo(target);
		}
	}
});
$('.statespage').on('change', function () {
	var target = $(this).parents(".register-form").find('#schools');
	target.empty();
	$('<option id="' + "Please Select" + '" value="' + "Please Select" + '">' + "Select School" + '</option>').appendTo(target);
	var schools = stateSchools[$(this).val()];
	if (states != undefined) {
		schools.sort();
		for(var i = 0; i < schools.length; i++) {
			$('<option id="' + schools[i] + '" value="' + schools[i] + '">' + schools[i] + '</option>').appendTo(target);
		}
      	$(target).append($('<option>', {
            value: 'Other',
            text: 'Other'
        }));
	}
});

$(window).on("load", function(){  
  d3.csv(document.getElementById("student-webdav-url")?.getAttribute("data-value"), function(data) {
    if(!countryValues.includes(data.DivisionCode)) {
      countryValues.push(data.DivisionCode);
    }
    if (data.DivisionCode in countryState){
      if (!countryState[data.DivisionCode].includes(data.ShipToStateCode)){
        countryState[data.DivisionCode].push(data.ShipToStateCode);
      }
    }else{
      countryState[data.DivisionCode] = [data.ShipToStateCode];
    }
    if (data.ShipToStateCode in stateSchools){
      if (!stateSchools[data.ShipToStateCode].includes(data.Name)){
        stateSchools[data.ShipToStateCode].push(data.Name);
      }
    }else{
      stateSchools[data.ShipToStateCode] = [data.Name];
    }
  });
});

$(".email-confirm").blur(function () {
  	var emailval = $(this).parents("form").find('.create-email').val();
	if ( $(this).val() === emailval) {
      $(this).parent().find(".match-msg").hide();
    } else {
      $(this).parent().find(".match-msg").show();
    }
});
$(".password-confirm").blur(function () {
  var passwordval = $(this).parents("form").find('.create-password').val();
  	if ( $(this).val() === passwordval) {
      $(this).parent().find(".match-msg").hide();
    } else {
      $(this).parent().find(".match-msg").show();
    }
});

$(".create-password").blur(function () {
  	if ( $(this).val().length >= 5) {
      $(this).parent().find(".match-msg").hide();
    } else {
      $(this).parent().find(".match-msg").show();
    }
});

$(".schools").on('change', function () {
  $(this).parent().next(".school-name").hide();
  $(this).parent().next(".school-name").find("input").removeAttr('required');
  if($(this).find('option:selected').val() == "Other") {
    $(this).parent().next(".school-name").show();
    $(this).parent().next(".school-name").find("input").attr('required', 'required');
  }
});

$('form.register-form').submit(function () {
 		var jsonObj = [];
        var state    = $(this).find('#states :selected').text();
        var school   = $(this).find('#schools :selected').text();
  		var schoolother   = $(this).find('.school-name input').val();
		var user    = $(this).find('.customer-registration input:checked').val();
  		var phone   = $(this).find('#phone').val();
  
        item = {}
        if(state) {
        	item ['State']     = state;
        }
        if(school != "Other") {
          	item ['School']        = school;
        }else {
        	item ['School']        = schoolother;
        }
        
        if($(this).find('input#privacyPolicyCheckBox').is(':checked')) {
          item ['Privacy Policy Consent']     = "Accepted";
        } else {
          item ['Privacy Policy Consent']     = "Rejected";
        }
  		if($(this).find('input#newsletterbox').is(':checked')) {
          item ['Email Consent']     = "Accepted";
        } else {
          item ['Email Consent']     = "Rejected";
        }
  		item ['Account']     = user;
  		item ['Phone']     = phone;

        jsonObj.push(item);
        var jsonString = JSON.stringify(jsonObj);
	$(this).find("#customedetails").val(jsonString);
    if(user === "UserType:STPStudent" || user === "UserType:STPStaff" ) {
      $(this).find("#custometags").val(user+", Pending");
    }else {
      $(this).find("#custometags").val(user);
    }
});

/**
 * ----------------------------------------------------------------------------------------------
 * Prevent tabbing out of modal dialog
 * ----------------------------------------------------------------------------------------------
 */
$(document).on('keydown', function(e) {
    var target = e.target;
    var shiftPressed = e.shiftKey;
    if (e.keyCode == 9) {
        if ($(target).parents('[role=dialog]').length) {
            var borderElem = shiftPressed ?
                                $(target).closest('[role=dialog]').find('input:visible,select:visible,button:visible,textarea:visible').first() 
                             :
                                $(target).closest('[role=dialog]').find('input:visible,select:visible,button:visible,textarea:visible').last();
            if ($(borderElem).length) {
                if ($(target).is($(borderElem))) {
                    return false;
                } else {
                    return true;
                }
            }
        }
    }
    return true;
});
$(document).ready(function() {
  setTimeout(function () {
    var slidemainwdth = $(".product__slider-main a.slide").width();
    var slidemainhght = $(".product__slider-main a.slide").height();
    $(".product__slider-main").find("iframe").width(slidemainwdth).height(slidemainhght);
  }, 300);
});


$(document).ready(function() {
  $('#play-video').on('click', function(ev) {
    var iframe_default_src = $('#youtube_video').attr('default-data-src');
    $("#youtube_video").attr('data-src', iframe_default_src);
    //$("#youtube_video")[0].src += "?autoplay=1";
    //$('#youtube_video')[0].click();
    //$('#youtube_video').trigger('click');
    ev.preventDefault();
  });
});

/* edit profile js */
$(".edit-field").hide();
$("#save-profile").hide();
$(".save-field").each(function () {
  var valinput = $(this).html();
  if(!valinput) {
    $(this).parent().hide();
  };
});
$("#edit-profile").click(function () {
  $(this).hide();
  $("#save-profile").show();
  $(".save-field").hide();
  $(".edit-field").show();
  $(".save-field").parent().show();
});
$("#save-profile").click(function () {
  $(this).hide();
  $("#edit-profile").show();
  $(".save-field").show();
  $(".edit-field").hide();
  $(".save-field").each(function () {
    var valinput = $(this).html();
    if(!valinput) {
      $(this).parent().hide();
    };
  });
  var jsonObj = [];
        var firstname    = $(this).parent().find('.firstname').val();
        var lastname   = $(this).parent().find('.lastname').val();
  		var phone   = $(this).parent().find('.phone').val();
		var dob    = $(this).parent().find('.dob').val();
  		var country   = $(this).parent().find('country').val();
        item = {}
        	item ['first_name']     = firstname;
          	item ['last_name']        = lastname;
        jsonObj.push(item);
        var jsonString = JSON.stringify(jsonObj);
	$(this).find("#customeupdatedetails").val(jsonString);
});

$( "#dob" ).datepicker();
/* edit profile js end */


/* Mini cart Aira expand */

// $(".header__cart-toggle").on("click", function(){
// 	if ($("#mini-cart").attr("aria-hidden") === "true") {
// 		$("#mini-cart").attr("aria-hidden", "false");
// 	} else {
// 		$("#mini-cart").attr("aria-hidden", "true");
// 	}
// });